import React, { Fragment, useState, useEffect, useRef } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive";
import "datatables.net-responsive-bs5";
import "jspdf";
import "jspdf-autotable";

const ValetCompany = () => {
    const token = localStorage.getItem("token");
    const tableRef = useRef(null);
    const [showForm, setShowForm] = useState(false);
    const [editingCompany, setEditingCompany] = useState(null);
    const [formData, setFormData] = useState({
        fiscal_identification: "",
        address: "",
        legal_name: "",
        email: "",
        phone: "",
        password: "",
        staffCount: 0,
    });

    useEffect(() => {
        if (token && tableRef.current) {
            const apiUrl = `${process.env.REACT_APP_PUBLIC_SERVER}/api/companies`;
            const dataTable = $(tableRef.current).DataTable({
                ajax: {
                    url: apiUrl,
                    type: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                    dataSrc: "",
                },
                columns: [
                    { title: "Nombre Fiscal", data: "legal_name" },
                    { title: "Identificación Fiscal", data: "fiscal_identification" },
                    { title: "Dirección", data: "address" },
                    { title: "Correo", data: "email" },
                    { title: "Teléfono", data: "phone" },
                    { title: "Cantidad de Valets", data: "valet_count" },
                    {
                        title: "Acciones",
                        data: null,
                        render: (data, type, row) => {
                            return `
                                <button class="btn btn-primary btn-sm edit-btn" data-id="${row.id}">Editar</button>
                                <button class="btn btn-danger btn-sm delete-btn" data-id="${row.id}">Eliminar</button>
                            `;
                        },
                    },
                ],
                responsive: true,
                dom: 'Bfrtip',
                buttons: [
                    { extend: 'excelHtml5', text: 'Exportar a Excel', className: 'btn btn-success' },
                    { extend: 'pdfHtml5', text: 'Exportar a PDF', className: 'btn btn-danger' },
                ],
                initComplete: function () {
                    this.api().columns().every(function () {
                        var column = this;
                        var select = $('<select><option value=""></option></select>')
                            .appendTo($(column.footer()).empty())
                            .on('change', function () {
                                var val = $.fn.dataTable.util.escapeRegex($(this).val());
                                column.search(val ? '^' + val + '$' : '', true, false).draw();
                            });

                        column.data().unique().sort().each(function (d, j) {
                            select.append('<option value="' + d + '">' + d + '</option>');
                        });
                    });
                },
            });

            // Delegar eventos para los botones dentro del DataTable
            $(tableRef.current).on('click', '.edit-btn', function () {
                const id = $(this).data('id');
                const company = dataTable.data().toArray().find(row => row.id === id);
                openForm(company);
            });

            $(tableRef.current).on('click', '.delete-btn', function () {
                const id = $(this).data('id');
                deleteCompany(id);
            });

            return () => {
                if (dataTable) {
                    dataTable.destroy();
                }
            };
        }
    }, [token]);

    const openForm = (company = null) => {
        setEditingCompany(company);
        if (company) {
            setFormData({
                fiscal_identification: company.fiscal_identification || "",
                address: company.address || "",
                legal_name: company.legal_name || "",
                email: company.email || "",
                phone: company.phone || "",
                password: "",
                staffCount: company.staffCount || 0,
            });
        } else {
            setFormData({
                fiscal_identification: "",
                address: "",
                legal_name: "",
                email: "",
                phone: "",
                password: "",
                staffCount: 0,
            });
        }
        setShowForm(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        try {
            if (editingCompany) {
                await axios.put(`${process.env.REACT_APP_PUBLIC_SERVER}/api/companies/${editingCompany.id}`, formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                await axios.post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/companies`, formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            $(tableRef.current).DataTable().ajax.reload();
            setShowForm(false);
        } catch (error) {
            console.error("Error al guardar la empresa:", error);
        }
    };

    const deleteCompany = async (id) => {
        if (window.confirm("¿Estás seguro de que deseas eliminar esta empresa?")) {
            try {
                await axios.delete(`${process.env.REACT_APP_PUBLIC_SERVER}/api/companies/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                $(tableRef.current).DataTable().ajax.reload();
            } catch (error) {
                console.error("Error al eliminar la empresa:", error);
            }
        }
    };

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Empresas de Valet" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12" className="text-right mb-3">
                        <Button color="success" onClick={() => openForm()}>
                            Agregar Empresa
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader><h5>Lista de Empresas</h5></CardHeader>
                            <CardBody>
                                <table ref={tableRef} className="table table-striped nowrap" style={{ width: "100%" }}>
                                    <tfoot>
                                        <tr>
                                            <th>Nombre Fiscal</th>
                                            <th>Identificación Fiscal</th>
                                            <th>Dirección</th>
                                            <th>Correo</th>
                                            <th>Teléfono</th>
                                            <th>Cantidad de Valets</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {showForm && (
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardHeader><h5>{editingCompany ? "Modificar Empresa" : "Agregar Empresa"}</h5></CardHeader>
                                <CardBody>
                                    <Form>
                                        <FormGroup>
                                            <Label for="fiscal_identification">Identificación Fiscal</Label>
                                            <Input type="text" name="fiscal_identification" value={formData.fiscal_identification} onChange={handleInputChange} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="address">Dirección</Label>
                                            <Input type="text" name="address" value={formData.address} onChange={handleInputChange} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="legal_name">Nombre Fiscal</Label>
                                            <Input type="text" name="legal_name" value={formData.legal_name} onChange={handleInputChange} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="email">Correo</Label>
                                            <Input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="phone">Teléfono</Label>
                                            <Input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="password">Contraseña</Label>
                                            <Input type="password" name="password" value={formData.password} onChange={handleInputChange} required={!editingCompany} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="staffCount">Número de Empleados</Label>
                                            <Input type="number" name="staffCount" value={formData.staffCount} onChange={handleInputChange} />
                                        </FormGroup>
                                        <Button color="primary" onClick={handleSubmit}>Guardar</Button>
                                        <Button color="secondary" onClick={() => setShowForm(false)} className="ml-2">Cancelar</Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Container>
        </Fragment>
    );
};

export default ValetCompany;